import React from 'react';
import { useHistory } from 'react-router-dom';
import { useLogin, useNotify } from 'ra-core';
import { SignInPage } from '../../components/ui/sign-in';

// const sampleTestimonials = [
//   {
//     avatarSrc: "https://randomuser.me/api/portraits/women/57.jpg",
//     name: "Sarah Chen",
//     handle: "@sarahdigital",
//     text: "Amazing platform! The user experience is seamless and the features are exactly what I needed."
//   },
//   {
//     avatarSrc: "https://randomuser.me/api/portraits/men/64.jpg",
//     name: "Marcus Johnson",
//     handle: "@marcustech",
//     text: "This service has transformed how I work. Clean design, powerful features, and excellent support."
//   },
//   {
//     avatarSrc: "https://randomuser.me/api/portraits/men/32.jpg",
//     name: "David Martinez",
//     handle: "@davidcreates",
//     text: "I've tried many platforms, but this one stands out. Intuitive, reliable, and genuinely helpful for productivity."
//   },
// ];

const SignInPageWrapper = () => {
  const login = useLogin();
  const notify = useNotify();
  const history = useHistory();

  const handleSignIn = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const data = Object.fromEntries(formData.entries());
    
    console.log("Sign In submitted:", data);
    
    try {
      // Utiliser le hook useLogin de react-admin
      await login({ username: data.email, password: data.password });
    } catch (error) {
      notify(
        typeof error === 'string'
          ? error
          : typeof error === 'undefined' || !error.message
          ? 'ra.auth.sign_in_error'
          : error.message,
        'warning'
      );
    }
  };

  const handleGoogleSignIn = () => {
    console.log("Continue with Google clicked");
    // Implémenter la logique de connexion Google ici
  };
  
  const handleResetPassword = () => {
    // Rediriger vers la page de réinitialisation
    history.push('/forgot-password');
  };

  const handleCreateAccount = () => {
    // Rediriger vers la page d'inscription
    // Note: La page d'inscription nécessite un token, donc on pourrait rediriger vers une page d'information
    console.log("Create Account clicked");
  };

  return (
    <SignInPage
      heroImageSrc="https://external-preview.redd.it/_hBu27b4O1p5_vyMUzseK_QmThFmJE80sbDkgLNfJYI.jpg?auto=webp&s=31696bcde387e98bdfa52668a94c9a6865f5fa25"
      // testimonials={sampleTestimonials}
      onSignIn={handleSignIn}
      onGoogleSignIn={handleGoogleSignIn}
      onResetPassword={handleResetPassword}
      onCreateAccount={handleCreateAccount}
    />
  );
};

export default SignInPageWrapper;

